import { getMessages } from '../../../../../../../store/constants';

export const BOARD_BUTTON_UNARCHIVE = getMessages().getText('board_details__link_unarchive');
